// Canonical portraits of Dr Tegbir Singh Sidhu.
// All shots delivered by the studio (2026). Hosted on Emergent CDN.
// Use these constants everywhere — never inline the URL.

export const PORTRAITS = {
  // FLAGSHIP HERO — arms crossed, white coat, window sidelight, direct eye contact.
  // Best for: HOME hero (kinetic parallax portrait) + OG default social share.
  HERO: "https://customer-assets-v7afamib.emergentagent.net/job_vascular-specialist/artifacts/h42j5vhh__DSC9521.webp",

  // Standing, arms crossed, white coat, window light — authoritative clinical.
  // Best for: ABOUT hero.
  ABOUT_HERO: "https://customer-assets-v7afamib.emergentagent.net/job_vascular-specialist/artifacts/tnxod6go__DSC9518.webp",

  // Full-body, standing in corridor, white coat, hands in pockets — striking presence.
  // Best for: About "In practice" left / How-It-Works split hero.
  FULL_BODY_CORRIDOR: "https://customer-assets-v7afamib.emergentagent.net/job_vascular-specialist/artifacts/43gyuof2__DSC9487.webp",

  // White coat, hands in pockets, editorial framing near window — bright, clean.
  // Best for: Contact page hero / About "In practice" right.
  COAT_EDITORIAL: "https://customer-assets-v7afamib.emergentagent.net/job_vascular-specialist/artifacts/t78ypjlu__DSC9512.webp",

  // Full-body, white coat, hands in pockets, clean bright corridor.
  // Best for: NRI hub hero / country-page cross-border presence.
  FULL_BODY_COAT: "https://customer-assets-v7afamib.emergentagent.net/job_vascular-specialist/artifacts/ng9616zt__DSC9516.webp",

  // Profile, looking out window, dark polo — contemplative narrative.
  // Best for: Why-Choose manifesto / editorial chapter break.
  PROFILE_WINDOW: "https://customer-assets-v7afamib.emergentagent.net/job_vascular-specialist/artifacts/uyml5287__DSC9510.webp",

  // Warmer/editorial shots — retained for future secondary/journal use.
  SEATED_WARM: "https://customer-assets-v7afamib.emergentagent.net/job_vascular-specialist/artifacts/u04nvmxl__DSC9442.webp",
  IN_ACTION: "https://customer-assets-v7afamib.emergentagent.net/job_vascular-specialist/artifacts/k69cmh1q__DSC9530.webp",
  CREDENTIALS: "https://customer-assets-v7afamib.emergentagent.net/job_vascular-specialist/artifacts/8yqn0v9t__DSC9465.webp",
  WINDOW: "https://customer-assets-v7afamib.emergentagent.net/job_vascular-specialist/artifacts/ls15bp2j__DSC9503.webp",
};

// Alt text is standardised so screen readers always identify Dr Sidhu correctly.
export const PORTRAIT_ALT = "Dr Tegbir Singh Sidhu — Interventional Radiologist";
